import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Super admin uses httpOnly cookies (withCredentials).
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Shop-scoped calls use Bearer token stored in localStorage keyed by slug.
export function shopApi(slug) {
  const token = localStorage.getItem(`relax_shop_token::${slug}`);
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export function setShopToken(slug, token, role, personName, personId, isSuperAdmin = false) {
  localStorage.setItem(`relax_shop_token::${slug}`, token);
  localStorage.setItem(`relax_shop_role::${slug}`, role);
  localStorage.setItem(`relax_shop_person::${slug}`, personName || "");
  if (personId) localStorage.setItem(`relax_shop_person_id::${slug}`, personId);
  else localStorage.removeItem(`relax_shop_person_id::${slug}`);
  if (isSuperAdmin) localStorage.setItem(`relax_shop_is_super::${slug}`, "1");
  else localStorage.removeItem(`relax_shop_is_super::${slug}`);
}

export function clearShopToken(slug) {
  localStorage.removeItem(`relax_shop_token::${slug}`);
  localStorage.removeItem(`relax_shop_role::${slug}`);
  localStorage.removeItem(`relax_shop_person::${slug}`);
  localStorage.removeItem(`relax_shop_person_id::${slug}`);
  localStorage.removeItem(`relax_shop_is_super::${slug}`);
}

export function getShopSession(slug) {
  return {
    token: localStorage.getItem(`relax_shop_token::${slug}`),
    role: localStorage.getItem(`relax_shop_role::${slug}`),
    person: localStorage.getItem(`relax_shop_person::${slug}`),
    person_id: localStorage.getItem(`relax_shop_person_id::${slug}`),
    is_super_admin: localStorage.getItem(`relax_shop_is_super::${slug}`) === "1",
  };
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return null;
  return `${API}/files/${path}`;
}

// helper for uploads
export async function uploadShopFile(slug, file, scope = "generic") {
  const form = new FormData();
  form.append("file", file);
  form.append("scope", scope);
  const token = localStorage.getItem(`relax_shop_token::${slug}`);
  const r = await axios.post(`${API}/shops/${slug}/upload`, form, {
    headers: token
      ? { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" }
      : { "Content-Type": "multipart/form-data" },
  });
  return r.data; // {path, url}
}

export async function uploadAdminFile(file, scope = "shops/generic") {
  const form = new FormData();
  form.append("file", file);
  form.append("scope", scope);
  const r = await adminApi.post(`/admin/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
}
